import { start as startWallDetection } from "./detection.js";
export function start() {
    startWallDetection();
}
start();
